export function useArticle(
  path: `/${"artikler" | "tilleggsopplysninger"}/${string}`,
) {
  const { time } = useServerTiming();
  const version = useCrystallizeVersion();
  return useQuery({
    queryKey: ["article", path],
    staleTime: 1000 * 60 * 60,
    queryFn: async () => {
      const data = await time("GetArticle", () =>
        GqlGetPage({
          language: "no-nb",
          path,
          version,
        }));

      return data?.catalogue ? toArticle(data.catalogue) : null;
    },
  });
}
